<template>
  <!-- コンテンツ -->
  <div id="content">
    <!-- タブ -->
    <div id="tab">
      <!-- ボタン -->
      <div class="button-area">
        <ul>
          <li>
            <label><input type="radio" :value="1" v-model="outputSheetType" :disabled="!isCheckSheets"/>PDF図面形式</label>
            <label><input type="radio" :value="2" v-model="outputSheetType" :disabled="!isCheckSheets"/>DXF図面形式</label>
          </li>
          <li>
            <button type="button" class="main_btn" v-bind:class="{img_disable: !canOutput}" @click="outputDocument">
              <img :src="imgSheet" alt="preview" width="24px" height="auto">チェックしたドキュメントの送信</button>
          </li>
          <li>
            <span>※出力物はメールで送られます</span>
          </li>
        </ul>
      </div>
      <ul class="tab_menu" id="group_tab">
        <li
          v-for="(tab, index) in tabGroupList"
          :key="index"
          class="dtl_menu_list"
        >
          <div class="tab_sub_menu">
            <div class="tab_name_area">
              <input type="checkbox" :value="tab.code" v-model="checkedGroupTypes" @change="changeGroupType(tab.code)"
                :class="{ 'img_disable': tab.disable }">
              {{ tab.label }}
              <span class="tooltip" v-if="tab.code === 4">
                <img :src="imgQMark" width="15px" height="auto"/>
                <span>
                  体験版は1プランのみ
                </span>
              </span>
            </div>
            <div class="drop_icon_area">
              <a @click="changeTabMenu(tab.code)"><img :src="imgDropDown" alt="preview" width="18px" height="auto"></a>
            </div>
          </div>
          <ul v-if="tab.isShow">
            <li
            v-for="(sheet, index) in getDispSheetList(tab.code)"
            :key="index"
            :class="{ 'active': sheet.code === activeSheet.code, 'img_disable': !sheet.enabled, 'manufacture_doc_text': sheet.code === 22 }"
            v-on:click.self="clickTab(sheet)"
            class="tab_dtl_menu"
            >
            <input type="checkbox" :value="sheet.code" v-model="checkedSheetTypes" :class="{ 'img_disable': !sheet.hasSheet || !sheet.hasLicense }">
              <span class="text" v-on:click.self="clickTab(sheet)">{{ sheet.label }}</span>
              <span :class="{ 'triangle': sheet.code === activeSheet.code, 'img_disable': !sheet.enabled }"></span>
              <div v-if="sheet.code === 22">
                <ul>
                  <li :class="{ 'active': sheet.code === activeSheet.code }">加工指示リスト</li>
                  <li :class="{ 'active': sheet.code === activeSheet.code }">コンバイン明細リスト</li>
                  <li :class="{ 'active': sheet.code === activeSheet.code }">梱包ラベル</li>
                </ul>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- タブのコンテンツ -->
    <div id="tab_contents">
      <!-- 図面の操作 -->
      <span v-if="isShowSheet">
        <div id="sheet">
          <!-- 図面リスト -->
          <div id="sheet-form">
            <div>
              <div>図面選択</div>
              <select
                      id="select-sheet-type"
                      v-if="sheetTypeList.length > 0"
                      v-model="selectedSheet"
                      @change="onSelectedSheetChange" >
                <template v-for="(sheetType, key, index) in sheetTypeList" >
                  <!-- オプショングループを持たないもの -->
                  <option
                          v-if="!sheetType.optionList"
                          :key="index"
                          :value="{ sheetType: sheetType.sheetTypeValue, spaceId: null, subType: null }" >
                    {{ sheetType.sheetTypeLabel }}
                  </option>
                  <!-- オプショングループを持つもの -->
                  <optgroup
                          :label="sheetType.sheetTypeLabel"
                          v-else
                          :key="index" >
                    <option
                            v-for="(option, key, index) in sheetType.optionList"
                            :key="index"
                            :value="{ sheetType: option.sheetTypeValue, spaceId: option.spaceId, subType: option.objectSubType }"
                            :selected="option.objectSubType === selectedSheet.subType"
                            v-if="sheetType.sheetTypeValue==2">
                      {{ option.label }}
                    </option>
                    <option
                            v-for="(option, key, index2) in sheetType.optionList"
                            :key="index2"
                            :value="{ sheetType: sheetType.sheetTypeValue, spaceId: option.spaceId, subType: option.objectSubType }"
                            :selected="option.objectSubType === selectedSheet.subType"
                            v-if="sheetType.sheetTypeValue!=2">
                      {{ option.label }}
                    </option>
                  </optgroup>
                </template>
              </select>
              <select
                      v-else
                      v-model="selectedSheet"
                      disabled
              >
                <option :value="{}">表示可能な図面はありません。</option>
              </select>
              <span class="message">
                {{ nestingMessage }}
              </span>
            </div>
          </div>
          <!-- 図面 -->
          <div id="sheet-disp-area"
              @contextmenu.prevent
                v-show="sheetTypeList.length > 0">
            <svg xmlns="http://www.w3.org/2000/svg"
                id="sheet-view"
                :width="svgBaseWidth"
                height="100%"
                transform="scale(1, -1)"
                :viewBox="sheetViewBox"
                preserveAspectRatio="xMinYMax meet"
                @wheel="wheelOnSheet"
                @mousemove="mousemoveOnSheet"
                @mousedown="mousedownOnSheet"
                @mouseup="mouseupOnSheet"
            >

              <!-- 表題欄・外枠 -->
              <g>
                <rect
                        v-for="(rect, index) in sheetModel.titleAreaRectList"
                        :key="'titleAreaRect_' + index"
                        :x="rect.startX"
                        :y="rect.startY"
                        :width="(rect.endX - rect.startX)"
                        :height="(rect.endY - rect.startY)"
                        :stroke="rect.color ? rect.color : 'black'"
                        :fill="rect.fillColor ? rect.fillColor : 'white'"/>
                <line
                        v-for="(line, index) in sheetModel.titleAreaLineList"
                        :key="'titleAreaLine_' + index"
                        :x1="line.startX"
                        :y1="line.startY"
                        :x2="line.endX"
                        :y2="line.endY"
                        :stroke="line.color ? line.color : 'black'"
                        :stroke-width="(line.lineWeight ? line.lineWeight : 1) * svgZoomRatio + 'px'"/>
              </g>
              <!-- コンバイン構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.combineBomList"
                      :key="'combineBomList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.itemNameX" :font-size="bom.font">{{ bom.itemName }}</text>
                <text :x="bom.sizeX" :font-size="bom.font">{{ bom.size }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.cabinetPatternX" :font-size="bom.font">{{ bom.cabinetPattern }}</text>
                <text :x="bom.otherItemNumberX" :font-size="bom.font">{{ bom.otherItemNumber }}</text>
              </g>
              <!-- ユニット構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.unitBomList"
                      :key="'unitBomList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.itemNameX" :font-size="bom.font">{{ bom.itemName }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
              </g>
              <!-- パーツ構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.partsBomList"
                      :key="'partsBomList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.partsNameX" :font-size="bom.font">{{ bom.partsName }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.sizeX" :font-size="bom.font">{{ bom.size }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
                <text :x="bom.figureNumberX" :font-size="bom.font">{{ bom.figureNumber }}</text>
              </g>
              <!-- 金具構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.fittingBomList"
                      :key="'fittingBomList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.partsNameX" :font-size="bom.font">{{ bom.partsName }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
                <text :x="bom.manufactureNameX" :font-size="bom.font">{{ bom.manufactureName }}</text>
                <text :x="bom.figureNumberX" :font-size="bom.font">{{ bom.figureNumber }}</text>
              </g>

              <!-- 仕上材リスト -->
              <g
                      v-for="(bom, index) in sheetModel.finishingMaterialList"
                      :key="'finishingMaterialList_' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text x="10" :font-size="bom.font">{{ bom.finishingMaterial }}</text>
              </g>

              <!-- カラー設定 -->
              <g
                      v-for="(bom, index) in sheetModel.colorBomList"
                      :key="'colorBomList' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.cabinetPatternX" :font-size="bom.font">{{ bom.cabinetPattern }}</text>
                <text :x="bom.colorMaterialNameX" :font-size="bom.font">{{ bom.colorMaterialName }}</text>
              </g>
              <!-- その他カラー設定 -->
              <g
                      v-for="(bom, index) in sheetModel.otherColorBomList"
                      :key="'otherColorBomList' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.otherItemNumberX" :font-size="bom.font">{{ bom.otherItemNumber }}</text>
              </g>
              <!-- オプション構成明細 -->
              <g
                      v-for="(bom, index) in sheetModel.optionBomList"
                      :key="'optionBomList' + index"
                      :transform="'translate(' + bom.startX + ' ' + bom.startY + ') scale(1, -1)'">
                <text :x="bom.noX" :font-size="bom.font">{{ bom.no }}</text>
                <text :x="bom.itemNumberX" :font-size="bom.font">{{ bom.itemNumber }}</text>
                <text :x="bom.itemNameX" :font-size="bom.font">{{ bom.itemName }}</text>
                <text :x="bom.quantityX" :font-size="bom.font">{{ bom.quantity }}</text>
              </g>

              <!-- 図面グループ単位 -->
              <g
                      v-for="(sheetGroup, index) in sheetModel.sheetGroupModelList"
                      :key="'sheetGroup_' + index"
              >
                <!-- 図面エリア（デバッグ用） -->
                  <!-- <g>
                    <rect :x="sheetGroup.startX - sheetGroup.areaWidth/2"
                      :y="sheetGroup.startY - sheetGroup.areaHeight/2"
                      :width="sheetGroup.areaWidth"
                      :height="sheetGroup.areaHeight"
                      fill-opacity="0"
                      stroke="red"
                      stroke-width="1"/>
                  </g> -->
                <!-- 図面名 -->
                <g :transform="'translate(' + sheetGroupLBX(sheetGroup) + ',' + sheetGroupLBY(sheetGroup) + ')' ">
                  <text font-size="20" transform="scale(1,-1)">
                    {{sheetGroup.sheetTitle}}
                  </text>
                </g>
                <!-- 矩形 -->
                <g>
                  <rect
                          v-for="(rect, index) in sheetGroup.rectPartsModelList"
                          :key="'rect_' + index"
                          :x="sheetGroupX(sheetGroup) + rect.startX * sheetModel.scale"
                          :y="sheetGroupY(sheetGroup) + rect.startY * sheetModel.scale"
                          :width="(rect.endX - rect.startX) * sheetModel.scale"
                          :height="(rect.endY - rect.startY) * sheetModel.scale"
                          :stroke="rect.color ? rect.color : 'black'"
                          :stroke-width="(rect.lineWeight ? rect.lineWeight : 1) * svgZoomRatio + 'px'"
                          :fill="rect.fillColor ? rect.fillColor : 'white'"/>
                </g>
                <!-- 線 -->
                <g>
                  <line
                          v-for="(line, index) in sheetGroup.linePartsModelList"
                          :key="'line_' + index"
                          :x1="sheetGroupX(sheetGroup) + line.startX * sheetModel.scale"
                          :y1="sheetGroupY(sheetGroup) + line.startY * sheetModel.scale"
                          :x2="sheetGroupX(sheetGroup) + line.endX * sheetModel.scale"
                          :y2="sheetGroupY(sheetGroup) + line.endY * sheetModel.scale"
                          :z="line.z"
                          :stroke="line.color ? line.color : 'black'"
                          :stroke-width="(line.lineWeight ? line.lineWeight : 1) * svgZoomRatio + 'px'"
                          :stroke-dasharray="getDashArray(line)"/>
                </g>
                <!-- 可動棚線 幅の４分の３の位置に出力 -->
                <g
                          v-for="(ms, index) in sheetGroup.movableShelfPointList"
                          :key="'ms_' + index"
                          :stroke-width="(ms.lineWeight ? ms.lineWeight : 1) * svgZoomRatio + 'px'"
                          fill="none"
                          stroke="black"
                >
                  <path
                            :d="'M ' + (sheetGroupX(sheetGroup) + ms.x * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + ms.y * sheetModel.scale)
                            + ' v ' + (30 * sheetModel.scale)
                            + ' l ' + (10 * sheetModel.scale) + ' ' + (-20 * sheetModel.scale)" />
                  <path
                            :d="'M ' + (sheetGroupX(sheetGroup) + ms.x * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + ms.y * sheetModel.scale)
                            + ' v ' + (-30 * sheetModel.scale)
                            + ' l ' + (-10 * sheetModel.scale) + ' ' + (20 * sheetModel.scale)" />
                </g>
                <!-- 木目方向線 幅の４分の１か高さの４分の３の位置に出力 -->
                <g
                          v-for="(grain, index) in sheetGroup.grainLineList"
                          :key="'grain_' + index"
                          :stroke-width="(grain.lineWeight ? grain.lineWeight : 1) * svgZoomRatio + 'px'"
                          fill="none"
                          stroke="black"
                >
                  <line
                          :x1="sheetGroupX(sheetGroup) + grain.startX * sheetModel.scale"
                          :y1="sheetGroupY(sheetGroup) + grain.startY * sheetModel.scale"
                          :x2="sheetGroupX(sheetGroup) + grain.endX * sheetModel.scale"
                          :y2="sheetGroupY(sheetGroup) + grain.endY * sheetModel.scale"
                          z="0"
                          :stroke="grain.color ? grain.color : 'black'"
                          :stroke-width="(grain.lineWeight ? grain.lineWeight : 1) * svgZoomRatio + 'px'"
                          :stroke-dasharray="getDashArray(grain)"/>
                  <path v-if="grain.startArrow"
                            :d="'M ' + (sheetGroupX(sheetGroup) + (grain.startX + grain.arrowX) * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + (grain.startY + grain.arrowY) * sheetModel.scale)
                            + ' l ' + (-grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)
                            + ' l ' + (grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)"
                            :transform="'rotate(' + grain.angle + ', ' + (sheetGroupX(sheetGroup) + grain.startX * sheetModel.scale) +', ' + (sheetGroupY(sheetGroup) + grain.startY * sheetModel.scale) + ')'"/>
                  <path v-if="grain.endArrow"
                            :d="'M ' + (sheetGroupX(sheetGroup) + (grain.endX - grain.arrowX) * sheetModel.scale) + ' ' + (sheetGroupY(sheetGroup) + (grain.endY + grain.arrowY) * sheetModel.scale)
                            + ' l ' + (grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)
                            + ' l ' + (-grain.arrowX * sheetModel.scale) + ' ' + (-grain.arrowY * sheetModel.scale)"
                            :transform="'rotate(' + grain.angle + ', ' + (sheetGroupX(sheetGroup) + grain.endX * sheetModel.scale) +', ' + (sheetGroupY(sheetGroup) + grain.endY * sheetModel.scale) + ')'"/>
                </g>
                <!-- 円 -->
                <g>
                  <circle
                          v-for="(circle, index) in sheetGroup.circlePartsModelList"
                          :key="'circle_' + index"
                          :cx="sheetGroupX(sheetGroup) + circle.x * sheetModel.scale"
                          :cy="sheetGroupY(sheetGroup) + circle.y * sheetModel.scale"
                          :r="circle.r * sheetModel.scale"
                          :stroke="circle.color ? circle.color : 'black'"
                          fill="none"
                          :stroke-width="(circle.lineWeight ? circle.lineWeight : 1) * svgZoomRatio + 'px'"
                          :stroke-dasharray="getDashArray(circle)" />
                </g>
                <!-- 円弧 -->
                <g>
                  <path
                          v-for="(arc, index) in sheetGroup.arcPartsModelList"
                          :key="'arc_' + index"
                          :d="buildPathData(sheetGroup, arc)"
                          :stroke="arc.color ? arc.color : 'black'"
                          fill="none"
                          :stroke-width="(arc.lineWeight ? arc.lineWeight : 1) * svgZoomRatio + 'px'"
                          :stroke-dasharray="getDashArray(arc)" />
                </g>
                <!-- 文字 -->
                <g
                        v-for="(text, index) in sheetGroup.textPartsModelList"
                        :key="'text_' + index"
                        :transform="'translate(' + text.x * sheetModel.scale + ' ' + text.y * sheetModel.scale + ') scale(1, -1)'"
                >
                  <text :transform="'rotate(-' + text.angle + ')'"
                        text-anchor="middle"
                        :font-size="text.font ? text.font : '12'">
                    {{ text.text }}
                  </text>
                </g>
                <!-- 寸法 -->
                <g>
                  <!-- 寸法線 -->
                  <line
                          v-for="(dim, index) in sheetGroup.dimensionPartsModelList"
                          :key="'dim_' + index"
                          :x1="sheetGroupX(sheetGroup) + dim.startX * sheetModel.scale"
                          :y1="sheetGroupY(sheetGroup) + dim.startY * sheetModel.scale"
                          :x2="sheetGroupX(sheetGroup) + dim.endX * sheetModel.scale"
                          :y2="sheetGroupY(sheetGroup) + dim.endY * sheetModel.scale"
                          :stroke="dim.lineColor ? dim.lineColor : 'black'"
                          :stroke-width="(dim.lineWeight ? dim.lineWeight : 1) * svgZoomRatio + 'px'" />
                  <circle
                          v-for="(dimPoint, index) in sheetGroup.dimensionPartsModelList"
                          :key="'dimPoint_' + index"
                          :cx="sheetGroupX(sheetGroup) + dimPoint.startX * sheetModel.scale"
                          :cy="sheetGroupY(sheetGroup) + dimPoint.startY * sheetModel.scale"
                          :r="dimPoint.point * svgZoomRatio"
                          stroke="black"
                          fill="black"
                          :stroke-width="dimPoint.lineWeight ? dimPoint.lineWeight : '1px'" />

                  <!-- 文字(移動・回転を伴うためグループ化) -->
                  <!-- 横内線の文字列（寸法値）が縦内線の文字列とぶつかりにくくするため中央からサイズの４分の１ずらす -->
                  <g
                          v-for="(dimText, index) in sheetGroup.dimensionPartsModelList"
                          v-if="dimText.text"
                          :key="'dimText' + index"
                          :transform="'translate(' + (sheetGroupX(sheetGroup) + (dimText.startX + dimText.endX) / (dimText.horizontaInside ? 4 : 2) * sheetModel.scale) + ' '
                                        + (sheetGroupY(sheetGroup) + (dimText.startY + dimText.endY) / 2 * sheetModel.scale) + ') '
                          + 'scale(1, -1)'"
                  >
                    <text
                            :transform="'translate(' + dimText.hposition + ',' + dimText.vposition + ') '
                            + 'rotate(-' + (dimText.textAngle ? dimText.textAngle : 0) + ')'"
                            text-anchor="middle"
                            :font-size="dimText.textSize ? dimText.textSize : '7'"
                            :fill="dimText.textColor ? dimText.textColor : 'black'"
                    >
                      {{ dimText.text }}
                    </text>
                  </g>
                </g>

                <g>
                  <g v-for="(origin, index) in sheetGroup.originMarkerList"
                    :key="'origin_' + index"
                  >
                    <line :x1="sheetGroupX(sheetGroup) + origin.x * sheetModel.scale"
                          :y1="sheetGroupY(sheetGroup) + origin.y * sheetModel.scale"
                          :x2="sheetGroupX(sheetGroup) + origin.vertex1.x * sheetModel.scale"
                          :y2="sheetGroupY(sheetGroup) + origin.vertex1.y * sheetModel.scale"
                          stroke="black"
                          :stroke-width="svgZoomRatio + 'px'"
                    />
                    <line :x1="sheetGroupX(sheetGroup) + origin.x * sheetModel.scale"
                          :y1="sheetGroupY(sheetGroup) + origin.y * sheetModel.scale"
                          :x2="sheetGroupX(sheetGroup) + origin.vertex2.x * sheetModel.scale"
                          :y2="sheetGroupY(sheetGroup) + origin.vertex2.y * sheetModel.scale"
                          stroke="black"
                          :stroke-width="svgZoomRatio + 'px'"
                    />
                    <line :x1="sheetGroupX(sheetGroup) + origin.vertex1.x * sheetModel.scale"
                          :y1="sheetGroupY(sheetGroup) + origin.vertex1.y * sheetModel.scale"
                          :x2="sheetGroupX(sheetGroup) + origin.vertex2.x * sheetModel.scale"
                          :y2="sheetGroupY(sheetGroup) + origin.vertex2.y * sheetModel.scale"
                          stroke="black"
                          :stroke-width="svgZoomRatio + 'px'"
                    />
                  </g>
                </g>

                <g v-show="isFrontOfPlanzu(sheetGroup)">
                  <line
                          v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
                          :key="'sec1_' + index"
                          :x1="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + getAdjustSecX(sec)"
                          :y1="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + getAdjustSecY(sec)"
                          :x2="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + sec.footX + getAdjustSecX(sec)"
                          :y2="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + sec.footY + getAdjustSecY(sec)"
                          :stroke="sec.lineColor ? dim.lineColor : 'black'"
                          :stroke-width="1 * svgZoomRatio + 'px'"
                  />
                  <line
                          v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
                          :key="'sec2_' + index"
                          :x1="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + getAdjustSecX(sec)"
                          :y1="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + getAdjustSecY(sec)"
                          :x2="sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + sec.lineX + getAdjustSecX(sec)"
                          :y2="sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + sec.lineY + getAdjustSecY(sec)"
                          :stroke="sec.lineColor ? dim.lineColor : 'black'"
                          :stroke-width="1 * svgZoomRatio + 'px'"
                  />
                  <g v-for="(sec, index) in sheetGroup.sectionPointPartsModelList"
                    :key="'secLabel_' + index"
                    :transform="'translate(' + (sheetGroupX(sheetGroup) + sec.x * sheetModel.scale + getAdjustSecX(sec)) + ','
                                          + (sheetGroupY(sheetGroup) + sec.y * sheetModel.scale + getAdjustSecY(sec)) + ') '
                          + 'scale(1, -1)'">
                    <text
                            :transform="'translate(' + sec.textXPos + ',' + sec.textYPos + ')'"
                            text-anchor="middle"
                            font-size="7"
                            fill="black">
                      {{ sec.label }}
                    </text>
                  </g>
                </g>
              </g>
              <!-- 表題欄・文字列 -->
              <g>
                <g
                        v-for="(text, index) in sheetModel.titleAreaTextList"
                        :key="'titleAreaText_' + index"
                        :transform="'translate(' + text.x + ' ' + text.y + ') scale(1, -1)'">
                  <text
                    :transform="'rotate(-' + (text.angle ? text.angle : 0) + ')'"
                    text-anchor="start"
                    :font-size="text.font ? text.font : '12'"
                    :font-weight="text.fontWeight ? 'bolder' : 'normal'">{{ text.text }}</text>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </span>

      <!-- 図面以外のプレビュー -->
      <!-- プレゼンシート -->
      <dd-presentation-sheet-tab
        v-if="isPresentation"
        ref="PresentationSheetTab"
        :presentationSheetModel="presentationSheetModel"
        @outputPresentationSheet="outputPresentationSheet"
      />
      <!-- 見積書 -->
      <dd-estimate
        v-if="isEstimate"
        ref="refEstimate"
        :orderCode="orderCode"
        :spaceJoincd="spaceJoincd"
      />
      <!-- 構成明細 -->
      <dd-bom
        v-if="isEBom || isMasterBom"
        :isEBom="isEBom"
        :isMasterBom="isMasterBom"
        :orderCode="orderCode"
        :rotCode="rotCode"
        :spaceJoincd="spaceJoincd"
      />
      <!-- その他説明文 -->
      <dd-info
        v-if="isProductionPlan || isManufactureDoc || isMaterialList || isPartsLabel || isNcData"
        :isProductionPlan="isProductionPlan"
        :isManufactureDoc="isManufactureDoc"
        :isMaterialList="isMaterialList"
        :isPartsLabel="isPartsLabel"
        :isNcData="isNcData"
      />
      <!-- RISE CSV -->
      <dd-lixil
        v-if="isLixilData"
        :orderCode="orderCode"
        :spaceJoincd="spaceJoincd"
      />
      <div v-if="isCg">
        <div class="data-area">
          <ul>
            <li class="text-title">フォトリアルCG出力方法</li>
            <li>「フォトリアルCG」左のチェックボックスをご選択いただき「チェックしたドキュメントの送信」をクリックください。<br>
              自動生成されたフォトリアルCGが添付されたメールが、登録メールアドレス宛に送られます。<br>
              以下にてお選びいただいた撮影位置から撮影したCGをご確認いただけます。</li>
            <li>
              <span class="label">撮影位置</span>
              <select v-model="cameraPosition" class="form_contents">
                <option v-for="(position, index) in cameraPositionList" :key= index :value="position.code" >{{position.label}}</option>
              </select>
            </li>
          </ul>
        </div>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import {API_URL, SVG_MIN_DEFAULT, SVG_ZOOM_RATIO_MIN, SVG_ZOOM_SPEED} from '../constants/App'
import {FACE_TYPE, LICENSE_TYPE, OUTPUT_TYPE} from '../constants/Type'
import Modal from '../components/common/Modal'
import * as LicenseUtil from '../utils/License'
import * as CalcUtil from 'lodash/math'
import LoadingModal from '../components/common/LoadingModal'
import PresentationSheetTab from '../components/sheet/PresentationSheetTab'
import BomPreview from '../components/sheet/BomPreview'
import LixilPreview from '../components/sheet/LixilPreview'
import EstimatePreview from '../components/sheet/EstimatePreview'
import Infomation from '../components/sheet/Infomation'
export default {
  name: 'Sheet',
  components: {
    'dd-modal': Modal,
    'dd-loading-modal': LoadingModal,
    'dd-presentation-sheet-tab': PresentationSheetTab,
    'dd-bom': BomPreview,
    'dd-lixil': LixilPreview,
    'dd-estimate': EstimatePreview,
    'dd-info': Infomation
  },
  data () {
    return {
      orderCode: '',
      spaceJoincd: '',
      rotCode: '',
      sheetModel: {},
      selectedSheet: {
        sheetType: null,
        spaceId: null,
        subType: null
      },
      sheetTypeList: [],
      viewX: 0,
      viewY: 0,
      viewWidth: 0,
      viewHeight: 0,
      titleAreaHeight: 0,
      svgZoomRatio: 1,
      svgBaseWidth: '100%',
      center: {
        x: 0,
        y: 0
      },
      viewBox: {
        minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0
      },
      prevPointOnCanvas: {
        x: 0,
        y: 0
      },
      drag: false,
      dragPoint: {
        x: 0,
        y: 0
      },
      /**
       * code シードコード,
       * label タブに表示するテキスト
       * isShow タブ内の一覧の表示の判定フラグ
       * disable チェックボックスの非活性判定フラグ
       */
      tabGroupList: [
        {
          code: 1,
          label: '基本メニュー',
          isShow: true,
          disable: false
        },
        {
          code: 2,
          label: '生産管理', // プラン単位用
          isShow: true,
          disable: false
        },
        {
          code: 3,
          label: '生産管理', // 生産計画単位用
          isShow: true,
          disable: false
        },
        {
          code: 4,
          label: '製造管理',
          isShow: true,
          disable: false
        },
        {
          code: 5,
          label: '加工データ',
          isShow: true,
          disable: false
        }
      ],
      /**
       * シート種別一覧 + 製造指示書
       * code シートコード,
       * label タブに表示するテキスト,
       * hasSheet 図面を一枚以上所持していて出力可能かの判定値,
       * hasLicense 出力のライセンスがあるかの判定値,
       * enabled タブが有効か,
       * タブグループNo
       */
      sheetList: [
        {
          code: 5,
          label: '意匠図面',
          hasSheet: false,
          hasLicense: false,
          enabled: true,
          tabGroup: 1
        },
        {
          code: 16,
          label: '見積書',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 1
        },
        {
          code: 18,
          label: 'フォトリアル CG',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 1
        },
        {
          code: 15,
          label: 'プレゼンシート',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 1
        },
        {
          code: 3,
          label: 'コンバイン図',
          hasSheet: false,
          hasLicense: false,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 2,
          label: 'ユニット図',
          hasSheet: false,
          hasLicense: true,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 1,
          label: '加工図',
          hasSheet: false,
          hasLicense: false,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 14,
          label: '木取り指示書(ランニングソー)',
          hasSheet: false,
          hasLicense: false,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 13,
          label: '木取り指示書(パネルソー)',
          hasSheet: false,
          hasLicense: false,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 19,
          label: '設計BOM / 資材一覧表',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 25,
          label: 'NC DATA',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 17,
          label: 'MasterBom',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 30,
          label: 'RISE CSV',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 2
        },
        {
          code: 21,
          label: '生産計画リスト',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 3
        },
        {
          code: 14,
          label: '木取り指示書(ランニングソー)',
          hasSheet: false,
          hasLicense: false,
          enabled: true,
          tabGroup: 3
        },
        {
          code: 13,
          label: '木取り指示書(パネルソー)',
          hasSheet: false,
          hasLicense: false,
          enabled: true,
          tabGroup: 3
        },
        {
          code: 23,
          label: '資材所要量一覧',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 3
        },
        {
          code: 24,
          label: 'パーツラベル',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 3
        },
        {
          code: 17,
          label: 'MasterBom',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 3
        },
        {
          code: 22,
          label: '製造指示',
          hasSheet: true,
          hasLicense: false,
          enabled: true,
          tabGroup: 4
        },
        {
          code: 0,
          label: 'テノーナー',
          hasSheet: false,
          hasLicense: false,
          enabled: false,
          tabGroup: 5
        },
        {
          code: 0,
          label: '木口貼り機',
          hasSheet: false,
          hasLicense: false,
          enabled: false,
          tabGroup: 5
        },
        {
          code: 0,
          label: 'NC ボーリングマシン',
          hasSheet: false,
          hasLicense: false,
          enabled: false,
          tabGroup: 5
        },
        {
          code: 0,
          label: 'NC ダボ打ち機',
          hasSheet: false,
          hasLicense: false,
          enabled: false,
          tabGroup: 5
        },
        {
          code: 0,
          label: '製造BOM (JCPコード)',
          hasSheet: false,
          hasLicense: false,
          enabled: false,
          tabGroup: 5
        }
      ],
      // タブで選択してる図面
      activeSheet: {},
      // チェックを入れてる図面グループ
      checkedGroupTypes: [],
      // チェックを入れてる図面種別
      checkedSheetTypes: [],
      /** 出力図面種別 */
      outputSheetType: 1,
      /** プレゼンシートモデル */
      presentationSheetModel: {},
      /** 構成明細情報 */
      csvDataMap: {},
      /** カメラ位置 */
      cameraPosition: 2,
      /** カメラ位置リスト */
      cameraPositionList: [
        {label: '右側：高さ1400mm', code: 0},
        {label: '右側：高さ700mm', code: 1},
        {label: '正面：高さ1400mm', code: 2},
        {label: '正面：高さ700mm', code: 3},
        {label: '左側：高さ1400mm', code: 4},
        {label: '左側：高さ700mm', code: 5}
      ],
      /** 木取り図用メッセージ */
      nestingMessage: '',
      imgSheet: this.getImage('pages/planning/icon_output.svg'),
      imgDropDown: this.getImage('pages/planning/icon_dropdown.svg'),
      imgQMark: this.getImage('pages/planning/qmark_gray.svg')
    }
  },
  computed: {
    sheetViewBox: function () {
      return this.viewBox.minX + ' ' + this.viewBox.minY + ' ' + this.viewBox.width + ' ' + this.viewBox.height
    },
    canOutput: function () {
      return Object.keys(this.checkedSheetTypes).length
    },
    dispTrialUserTools: function () {
      let user = App.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    },
    isNestingSheet: function () {
      return [OUTPUT_TYPE.OUTPUT_NESTING_RUNNNING.code, OUTPUT_TYPE.OUTPUT_NESTING_PANEL.code].includes(this.activeSheet.code)
    },
    isPresentation: function () {
      return OUTPUT_TYPE.OUTPUT_PRESENTATION.code === this.activeSheet.code
    },
    isEstimate: function () {
      return OUTPUT_TYPE.OUTPUT_ESTIMATE.code === this.activeSheet.code
    },
    isEBom: function () {
      return OUTPUT_TYPE.OUTPUT_E_BOM.code === this.activeSheet.code
    },
    isMasterBom: function () {
      return OUTPUT_TYPE.OUTPUT_MASTER_BOM.code === this.activeSheet.code
    },
    isProductionPlan: function () {
      return OUTPUT_TYPE.OUTPUT_PRODUCTION_PLAN.code === this.activeSheet.code
    },
    isManufactureDoc: function () {
      return OUTPUT_TYPE.OUTPUT_MANUFACTURE_DOC.code === this.activeSheet.code
    },
    isMaterialList: function () {
      return OUTPUT_TYPE.OUTPUT_MATERIAL_LIST.code === this.activeSheet.code
    },
    isPartsLabel: function () {
      return OUTPUT_TYPE.OUTPUT_PARTS_LABEL.code === this.activeSheet.code
    },
    isCg: function () {
      return OUTPUT_TYPE.OUTPUT_CG.code === this.activeSheet.code
    },
    isLixilData: function () {
      return OUTPUT_TYPE.OUTPUT_RISE.code === this.activeSheet.code
    },
    isNcData: function () {
      return OUTPUT_TYPE.OUTPUT_NC_DATA.code === this.activeSheet.code
    },
    isShowSheet: function () {
      return !(this.isPresentation || this.isEstimate || this.isEBom || this.isMasterBom || this.isProductionPlan ||
        this.isManufactureDoc || this.isMaterialList || this.isPartsLabel || this.isCg || this.isPresentation || this.isLixilData || this.isNcData)
    },
    isOutputMasterBom: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.outputBomMaster
    },
    isDebug: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.tabMenuDebug
    },
    isLixil: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.outputLixil
    },
    isCheckSheets: function () {
      let checkFlg = false
      this.sheetList
        .filter(sheet => sheet.hasSheet)
        .filter(sheet => [OUTPUT_TYPE.OUTPUT_SH_PROCESS.code, OUTPUT_TYPE.OUTPUT_SH_PLAN.code,
          OUTPUT_TYPE.OUTPUT_SH_COMB.code, OUTPUT_TYPE.OUTPUT_SH_UNIT.code, OUTPUT_TYPE.OUTPUT_NESTING_PANEL.code, OUTPUT_TYPE.OUTPUT_NESTING_RUNNNING.code].includes(sheet.code))
        .forEach(sheet => {
          this.checkedSheetTypes.forEach(code => {
            if (code === sheet.code) {
              checkFlg = true
            }
          })
        })
      return checkFlg
    },
    /** FTP転送ライセンスフラグ */
    isUseFtp: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.sendFtp
    }
  },
  methods: {
    /** 表示対象のプレビュー情報を取得 */
    getSheet: function () {
      // URLパラメータからspaceJoincdを取得する
      this.spaceJoincd = this.$route.query.spaceJoincd
      this.orderCode = this.$route.query.orderCode
      this.rotCode = this.$route.query.rotCode
      this.propertyId = this.$route.query.propertyId
      this.sheetModel = {}
      // 見積書・構成明細・CGは各コンポーネントで処理
      if (this.isEstimate || this.isEBom || this.isMasterBom || this.isProductionPlan || this.isManufactureDoc ||
        this.isMaterialList || this.isPartsLabel || this.isCg || this.isLixilData || this.isNcData) {
        return
      }
      // プレゼンシートをアクティブにした場合は、表示対象が図面ではないため別処理とする
      if (this.isPresentation) {
        this.getPresentationSheetPreview()
        return
      }
      let urlStr = ''
      if (this.rotCode != null) {
        urlStr = API_URL.PREVIEW + '/manufacture/sheet'
      } else if (this.orderCode == null) {
        urlStr = API_URL.PREVIEW + '/sheet'
      } else {
        urlStr = API_URL.ORDER + '/detail/sheet'
      }
      this.$refs.loadingModalRef.showModal(true)
      console.dir(this.selectedSheet)
      axios.get(urlStr, {
        params: {
          orderCode: this.orderCode,
          rotCode: this.rotCode,
          sheetType: this.activeSheet.code,
          spaceId: this.selectedSheet.spaceId,
          spaceJoincd: this.spaceJoincd,
          page: Number.isInteger(this.selectedSheet.subType) ? this.selectedSheet.subType - 1 : 0,
          scale: this.sheetModel ? this.sheetModel.planOriginalScale : 0,
          propertyId: this.$route.query.propertyId
        }
      }).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        console.log('▼▼▼▼　DEBUG:GET SHEET DATA ▼▼▼▼')
        console.log(response)
        console.log('▲▲▲▲　DEBUG:GET SHEET DATA ▲▲▲▲')
        if (response.data.errorMessage) {
          this.sheetTypeList = []
          App.showModal({
            messages: [response.data.errorMessage]
          })
        } else if (response.data.data) {
          this.sheetModel = Object.assign({}, response.data.data.sheetModel)
          this.sheetTypeList = response.data.data.sheetTypeList
          if (this.sheetTypeList.length > 0) {
            this.selectedSheet.sheetType = this.sheetTypeList[0].sheetTypeValue
            let option = (this.sheetTypeList[0].optionList && this.sheetTypeList[0].optionList[0]) || null
            this.selectedSheet.spaceId = this.selectedSheet.spaceId != null ? this.selectedSheet.spaceId : (option ? option.spaceId : null)
            this.selectedSheet.subType = Number.isInteger(this.selectedSheet.subType) ? this.selectedSheet.subType : (option ? option.objectSubType : null)
            // ユニット拡大図追加
            if (this.selectedSheet.sheetType === OUTPUT_TYPE.OUTPUT_SH_UNIT.code && this.selectedSheet.subType === 501) {
              if (this.sheetTypeList[0].optionList != null && this.sheetTypeList[0].optionList.length > 0) {
                this.selectedSheet.sheetType = OUTPUT_TYPE.OUTPUT_SH_UNIT_CLOSEUP.code
              }
            }
            // add DCD-355 20230719 start
            if (this.selectedSheet.sheetType === OUTPUT_TYPE.OUTPUT_SH_PLAN.code && this.selectedSheet.subType === 1000) { // 1000:現調記入用紙
              this.selectedSheet.sheetType = OUTPUT_TYPE.OUTPUT_SH_PLAN_GENCHOU.code // 現調記入用紙 TYPE_SHT_PLAN_GENCHOU
            }
            // add DCD-355 20230719 end
            this.viewWidth = this.sheetModel.sheetWidth
            this.viewHeight = this.sheetModel.sheetHeight
            this.titleAreaHeight = this.sheetModel.titleAreaHeight
            this.viewBox.minX = 0
            this.viewBox.minY = 0
            this.viewBox.width = this.viewWidth
            this.viewBox.height = this.viewHeight
            this.svgZoomRatio = 1
          }
        }
        if (!this.sheetTypeList.length > 0) {
          this.selectedSheet = {}
        }
        if (this.isNestingSheet && this.dispTrialUserTools) {
          this.nestingMessage = '※体験版のため、１プランのみを対象としております。'
        } else {
          this.nestingMessage = ''
        }
        this.svgBaseWidth = this.activeSheet.code === OUTPUT_TYPE.OUTPUT_NESTING_PANEL.code ? '50%' : '100%'
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    /** 出力選択対象のドキュメントの一覧を取得 */
    hasSheet: function () {
      let urlStr = ''
      if (this.rotCode != null) {
        urlStr = API_URL.PREVIEW + '/manufacture/has-sheet-list'
      } else if (this.orderCode && this.orderCode.length > 0) {
        urlStr = API_URL.ORDER + '/detail/has-sheet-list'
      } else {
        urlStr = API_URL.PREVIEW + '/has-sheet-list'
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.get(urlStr, {
        params: {
          orderCode: this.orderCode,
          rotCode: this.rotCode,
          spaceJoincd: this.spaceJoincd,
          propertyId: this.$route.query.propertyId
        }
      }).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        console.log('▼▼▼▼　DEBUG:GET SHEET COUNT DATA ▼▼▼▼')
        console.log(response)
        console.log('▲▲▲▲　DEBUG:GET SHEET COUNT DATA ▲▲▲▲')
        this.sheetList.forEach(sheet => {
          // 図面を所持しているかの判定
          let hasSheet = response.data.data[sheet.code]
          if (hasSheet) {
            sheet.hasSheet = hasSheet
          }
          let hasLicense = LicenseUtil.checkLicense(sheet.code)
          if (hasLicense) {
            sheet.hasLicense = hasLicense
          }
          if (sheet.code === 2 && this.isLixil) {
            sheet.enabled = false
          }
          // デバッグ可能ユーザーまたはMasterBomライセンス保有者、体験版ユーザーのみ活性
          if (sheet.code === OUTPUT_TYPE.OUTPUT_MASTER_BOM.code) {
            sheet.enabled = (this.isDebug || this.isOutputMasterBom || this.dispTrialUserTools)
          }
        })
        this.getSheet()
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    /** 表示する出力メニュー一覧の取得 */
    getDispSheetList: function (code) {
      // LIXILでない場合、RISE CSVを非表示
      let lixilFilter = !this.isLixil ? tab => tab.code !== OUTPUT_TYPE.OUTPUT_RISE.code : () => true
      // デバッグ可能ユーザーまたはMasterBomライセンス保有者、体験版ユーザー以外は、MasterBomを非表示
      let debugUserFilter = !(this.isDebug || this.isOutputMasterBom || this.dispTrialUserTools) ? tab => tab.code !== OUTPUT_TYPE.OUTPUT_MASTER_BOM.code : () => true

      return this.sheetList
        .filter(lixilFilter)
        .filter(debugUserFilter)
        .filter(sheet => sheet.tabGroup === code)
    },
    /** グループ一括チェックの変更 */
    changeGroupType: function (code) {
      let checkedFlg = this.checkedGroupTypes.filter(group => group === code) > 0
      let changeTabList = this.sheetList.filter(sheet => sheet.tabGroup === code)
      if (checkedFlg) {
        changeTabList.forEach(tab => {
          let isNon = (this.checkedSheetTypes.filter(sheet => sheet === tab.code).length === 0)
          if (tab.hasSheet && tab.hasLicense && tab.enabled && isNon) {
            this.checkedSheetTypes.push(tab.code)
          }
        })
      } else {
        this.checkedSheetTypes = this.checkedSheetTypes.filter(sheet => {
          let flg = true
          changeTabList.forEach(tab => {
            if (tab.code === sheet) {
              flg = false
            }
          })
          return flg
        })
      }
    },
    /** グループ毎のメニュー表示切り替え */
    changeTabMenu: function (code) {
      this.tabGroupList.forEach(tab => {
        if (tab.code === code) {
          tab.isShow = !tab.isShow
        }
      })
    },
    clickTab: function (sheet) {
      if (sheet.code !== 0) {
        this.activeSheet = sheet
        this.selectedSheet = {
          sheetType: null,
          spaceId: null,
          subType: null
        }
        this.getSheet()
      }
    },
    /** 表示図面変更時処理 */
    onSelectedSheetChange: function () {
      this.cacheFlg = 0
      this.getSheet()
    },
    viewBoxForSheetGroup: function (sheetGroup) {
      return (-sheetGroup.leftMargin * this.sheetModel.scale) + ' ' +
              (-sheetGroup.bottomMargin * this.sheetModel.scale) + ' ' +
              this.sheetModel.sheetWidth + ' ' +
              this.sheetModel.sheetHeight
    },
    sheetGroupX: function (sheetGroup) {
      return sheetGroup.startX - (sheetGroup.width / 2) * this.sheetModel.scale
    },
    sheetGroupY: function (sheetGroup) {
      return sheetGroup.startY - (sheetGroup.height / 2) * this.sheetModel.scale
    },
    sheetGroupLBX: function (sheetGroup) {
      switch (sheetGroup.faceType) {
        case FACE_TYPE.TOP:
        case FACE_TYPE.BOTTOM:
          return sheetGroup.startX - sheetGroup.areaWidth / 2 + 300
        case FACE_TYPE.FRONT:
        case FACE_TYPE.BACK:
        case FACE_TYPE.LEFT:
        case FACE_TYPE.RIGHT:
          return sheetGroup.startX - sheetGroup.areaWidth / 2 + 120
        default:
          return sheetGroup.startX - sheetGroup.areaWidth / 2
      }
    },
    sheetGroupLBY: function (sheetGroup) {
      switch (sheetGroup.faceType) {
        case FACE_TYPE.TOP:
        case FACE_TYPE.BOTTOM:
          // return sheetGroup.startY - sheetGroup.areaHeight / 2 - 65 // mdf DCD-406 20230711
          return sheetGroup.startY - sheetGroup.areaHeight / 2 - 40
        case FACE_TYPE.FRONT:
        case FACE_TYPE.BACK:
        case FACE_TYPE.LEFT:
        case FACE_TYPE.RIGHT:
          // return sheetGroup.startY - sheetGroup.areaHeight / 2 - 50 // mdf DCD-406 20230711
          return sheetGroup.startY - sheetGroup.areaHeight / 2 - 40
        default:
          return sheetGroup.startY - sheetGroup.areaHeight / 2
      }
    },
    mousemoveOnSheet: function (event) {
      if (this.drag) {
        let moveX = (this.dragPoint.x - event.clientX) * this.svgZoomRatio
        let moveY = (this.dragPoint.y - event.clientY) * this.svgZoomRatio

        this.viewBox.minX += moveX
        this.viewBox.minY -= moveY

        this.setViewBox(this.viewBox.minX + moveX, this.viewBox.minY - moveY, this.viewBox.width, this.viewBox.height)

        this.dragPoint.x = event.clientX
        this.dragPoint.y = event.clientY
      }
    },
    mousedownOnSheet: function (event) {
      if (event.buttons === 2 && !this.drag) {
        this.drag = true
        this.dragPoint.x = event.clientX
        this.dragPoint.y = event.clientY
      }
    },
    mouseupOnSheet: function (event) {
      if (this.drag) {
        this.drag = false
      }
    },
    wheelOnSheet: function (event) {
      this.setCurrentPointerPositionOnCanvas(event, this.viewBox)
      let d = Math.sign(event.wheelDelta)
      this.zoomCanvas(d)
    },
    zoomCanvas: function (wheelAmount) {
      let prevSvgZoomRatio = this.svgZoomRatio
      for (let {threshold, speed} of SVG_ZOOM_SPEED) {
        // ズームインの場合は閾値含まず、ズームアウトの場合は閾値含む
        if ((Math.sign(wheelAmount) > 0 && this.svgZoomRatio > threshold) ||
                (Math.sign(wheelAmount) < 0 && this.svgZoomRatio >= threshold)) {
          this.svgZoomRatio -= Math.sign(wheelAmount) * speed
          break
        }
      }
      // 小数点以下2桁で丸める
      this.svgZoomRatio = Math.round(this.svgZoomRatio * 100) / 100
      if (this.svgZoomRatio < SVG_ZOOM_RATIO_MIN) {
        this.svgZoomRatio = SVG_ZOOM_RATIO_MIN
        return
      }
      // 原寸以下には縮小しない
      if (this.svgZoomRatio >= 1) {
        this.viewBox.minX = 0
        this.viewBox.minY = 0
        this.viewBox.width = this.viewWidth
        this.viewBox.height = this.viewHeight
        this.svgZoomRatio = 1
        return
      }
      // マウスカーソルの位置を基準にズームする
      let x = this.currentPointOnCanvas.x
      let y = this.currentPointOnCanvas.y

      let width = Math.round(this.viewWidth * this.svgZoomRatio)
      let height = Math.round(this.viewHeight * this.svgZoomRatio)

      let tmpZoomRatio = this.svgZoomRatio / prevSvgZoomRatio

      let newMinX = x - (x - this.viewBox.minX) * tmpZoomRatio
      let newMinY = y - (y - this.viewBox.minY) * tmpZoomRatio

      this.setViewBox(newMinX, newMinY, width, height)
    },
    mouseWheel: function (event) {
      // 図面内でのスクロールイベントの場合、画面をスクロールさせない
      // スクロールした要素から親の要素を見ていき、対象のidを持つ要素があったら図面内と判定する
      if (event.composedPath().find(path => path.id === 'sheet-view')) {
        event.preventDefault()
      }
    },
    /** 現在のマウスポインタ位置設定(ローカル) */
    setCurrentPointerPositionOnCanvas: function (event, viewBox) {
      this.currentPointOnCanvas = {
        x: CalcUtil.round(event.offsetX * this.svgZoomRatio + viewBox.minX, 1),
        y: CalcUtil.round(event.offsetY * this.svgZoomRatio + viewBox.minY, 1)
      }
    },
    /** SVGのビューボックスに値を設定する */
    setViewBox: function (minX, minY, width, height) {
      this.viewBox.width = width
      this.viewBox.height = height
      if (minX < 0) {
        this.viewBox.minX = 0
      } else if (this.viewWidth < minX + width) {
        this.viewBox.minX = this.viewWidth - width
      } else {
        this.viewBox.minX = minX
      }

      if (this.svgZoomRatio === 1) {
        this.viewBox.minY = 0
      } else if (minY < -this.titleAreaHeight / 4 / this.svgZoomRatio) {
        this.viewBox.minY = -this.titleAreaHeight / 4 / this.svgZoomRatio
      } else if (this.viewHeight < minY + height) {
        this.viewBox.minY = this.viewHeight - height
      } else {
        this.viewBox.minY = minY
      }
    },
    buildPathData: function (sheetGroup, arc) {
      let scale = this.sheetModel.scale
      let x = this.sheetGroupX(sheetGroup)
      let y = this.sheetGroupY(sheetGroup)
      let d = ''
      d += 'M '
      d += (x + (arc.startX) * scale) + ' '
      d += (y + (arc.startY) * scale) + ' '
      d += 'A '
      d += arc.rw * scale + ' '
      d += arc.rh * scale + ' '
      d += '0 '
      d += (arc.longer ? '1' : '0') + ' '
      d += (arc.cw ? '1' : '0') + ' '
      d += (x + (arc.endX) * scale) + ' '
      d += (y + (arc.endY) * scale)
      return d
    },
    getDashArray: function (parts) {
      let dashed = 3
      if (parts.ltype === 'DOT') {
        dashed *= this.svgZoomRatio
        return dashed + ' ' + dashed + ' '
      }
      return ''
    },
    convertSectionPoints: function (sectionList) {
      return []
    },
    /** ドキュメントの一括送信 */
    outputDocument: function () {
      let refsEstimate = this.$refs.refEstimate
      let payload = {
        sheetTypes: this.checkedSheetTypes,
        cdSpaceJoincd: this.$route.query.spaceJoincd,
        orderCode: this.orderCode,
        rotCode: this.rotCode,
        cameraPosition: this.cameraPosition,
        outputType: this.outputSheetType,
        previewEstimate: refsEstimate != null ? refsEstimate.getPreviewEstimate() : null,
        propertyId: this.$route.query.propertyId
      }
      let urlStr = ''
      if (this.orderCode == null) {
        urlStr = API_URL.OUTPUT
      } else {
        urlStr = API_URL.ORDER + '/detail/sheet/output'
      }

      this.$refs.loadingModalRef.showModal(true)
      axios.post(urlStr, payload)
        .then(response => {
          setTimeout(function () {
            this.$refs.loadingModalRef.showModal(false)
            if (response.data.errorMessage) {
              App.showModal({
                title: 'エラー',
                messages: [response.data.errorMessage],
                messageType: 'error'
              })
            } else if (this.isUseFtp) {
              App.showModal({
                messages: ['※出力物はサーバーにて自動生成完了後、', 'FTPサーバー宛に送られます', '(FTP登録をしていなければ登録されたメールアドレス宛に送られます)。'],
                onOk: () => {
                  this.checkedSheetTypes = []
                  this.checkedGroupTypes = []
                }
              })
            } else {
              App.showModal({
                messages: ['※出力物はサーバーにて自動生成完了後、', '登録されたメールアドレス宛に送られます。'],
                onOk: () => {
                  this.checkedSheetTypes = []
                  this.checkedGroupTypes = []
                }
              })
            }
          }.bind(this), 2000)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    scrollTabById: function (id, isLeft) {
      const scrollAmount = 500
      let element = document.getElementById(id)
      element.scrollLeft += (isLeft ? -1 : 1) * scrollAmount
    },
    getPresentationSheetPreview: function () {
      // プレゼンシートに関しては、さしあたって、orderCode有無にかかわらず、同じAPIを利用し、
      // API_URL.PREVIEWとAPI_URL.ORDER + 'xxxxx'といった使い分けをしない。
      let urlStr = API_URL.PREVIEW + '/presentation-sheet'
      this.$refs.loadingModalRef.showModal(true)
      axios.get(urlStr, {
        params: {
          spaceJoincd: this.spaceJoincd,
          propertyId: this.$route.query.propertyId
        }
      }).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        if (response.data.errorMessage) {
          App.showModal({
            title: 'エラー',
            messages: [response.data.errorMessage],
            messageType: 'error'
          })
        } else {
          this.presentationSheetModel = Object.assign({}, response.data.data)
        }
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    // TODO チェックボックスによる一括出力の対象なら要対応
    outputPresentationSheet: function () {
      let urlStr = API_URL.OUTPUT + '/presentation-sheet'
      this.$refs.loadingModalRef.showModal(true)
      axios.get(urlStr, {
        params: {
          spaceJoincd: this.spaceJoincd,
          propertyId: this.$route.query.propertyId
        }
      }).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        if (response.data.errorMessage) {
          App.showModal({
            title: 'エラー',
            messages: [response.data.errorMessage],
            messageType: 'error'
          })
        } else {
          App.showModal({
            messages: ['※出力物はサーバーにて自動生成完了後、', '登録されたメールアドレス宛に送られます。']
          })
        }
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    },
    // 意匠図の正面図か add DCD-407 20230712
    isFrontOfPlanzu: function (sheetGroup) {
      let ret = (sheetGroup.faceType === FACE_TYPE.FRONT) && (OUTPUT_TYPE.OUTPUT_SH_PLAN.code === this.activeSheet.code)
      return ret
    },
    // 断面位置の調整値を取得する add DCD-407 20230712
    getAdjustSecX: function (sec) {
      if (sec.axis === 'Y' && sec.outside === false) {
        return -60
      } else if (sec.axis === 'Y' && sec.outside === true) {
        return 60
      } else {
        return 0
      }
    },
    getAdjustSecY: function (sec) {
      if (sec.axis === 'X' && sec.outside === false) {
        return -60
      } else if (sec.axis === 'X' && sec.outside === true) {
        return 60
      } else {
        return 0
      }
    },
    onOutputEstimate: function () {
      let refsEstimate = this.$refs.refEstimate
      let payload = {}
      if (refsEstimate === undefined) {
        payload = {
          sheetTypes: this.checkedSheetTypes,
          cdSpaceJoincd: this.$route.query.spaceJoincd,
          orderCode: this.orderCode,
          rotCode: this.rotCode,
          cameraPosition: this.cameraPosition,
          outputType: this.outputSheetType,
          propertyId: this.$route.query.propertyId
        }
      } else {
        let estimate = refsEstimate.estimate
        payload = {
          sheetTypes: this.checkedSheetTypes,
          cdSpaceJoincd: this.$route.query.spaceJoincd,
          orderCode: this.orderCode,
          rotCode: this.rotCode,
          cameraPosition: this.cameraPosition,
          outputType: this.outputSheetType,
          propertyId: this.$route.query.propertyId,
          createdAt: estimate.createdAt,
          planId: estimate.planId,
          parsonName: estimate.parsonName,
          clientName: estimate.clientName,
          clientDepartment: estimate.clientDepartment,
          clientParsonName: estimate.clientParsonName,
          deliveryName: estimate.deliveryName,
          propertyName: estimate.propertyName,
          planName: estimate.planName,
          deliveryAddr1: estimate.deliveryAddr1,
          deliveryAddr2: estimate.deliveryAddr2,
          deliveryDate: estimate.deliveryDate,
          paymentConditions: estimate.paymentConditions,
          materialMagProb: estimate.materialMagProb,
          processCost: estimate.processCost,
          productMagCost: estimate.productMagCost,
          factoryProfit: estimate.factoryProfit,
          facttransCost: estimate.facttransCost,
          profitRate1: this.convertProb(estimate.profitRate1),
          profitRate2: this.convertProb(estimate.profitRate2),
          profitRate3: this.convertProb(estimate.profitRate3),
          profitRate4: this.convertProb(estimate.profitRate4),
          deliveryCost: estimate.deliveryCost,
          executionCost: estimate.executionCost,
          processCostOrigin: estimate.processCostOrigin,
          processTime: estimate.processTime,
          constructionCost: estimate.constructionCost
        }
      }
      console.log('onOutputEstimate')
      console.dir(payload)
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.OUTPUT + '/download/estimate', payload, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }})
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'estimate.xlsx')
          document.body.appendChild(link)
          link.click()
          link.remove()
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    convertProb: function (val) {
      return val / 100
    }
  },
  mounted: function () {
    this.spaceJoincd = this.$route.query.spaceJoincd
    this.orderCode = this.$route.query.orderCode
    this.rotCode = this.$route.query.rotCode

    // 意匠図面がデフォルト表示
    this.activeSheet = this.sheetList[0]

    // プレビュー画面の初期表示を指定
    if (this.orderCode) {
      this.tabGroupList = this.tabGroupList.filter(tab => [1, 2].includes(tab.code))
    } else if (this.rotCode) {
      this.tabGroupList = this.tabGroupList.filter(tab => [3, 4].includes(tab.code))
      if ((this.isDebug || this.isOutputMasterBom)) {
        // MasterBomがデフォルト表示
        this.activeSheet = this.sheetList.find(sheet => sheet.code === OUTPUT_TYPE.OUTPUT_MASTER_BOM.code)
      } else {
        // 木取り図(ランニングソー)がデフォルト表示
        this.activeSheet = this.sheetList.find(sheet => sheet.code === OUTPUT_TYPE.OUTPUT_NESTING_RUNNNING.code)
      }
    } else {
      this.tabGroupList = this.tabGroupList.filter(tab => [1, 2, 5].includes(tab.code))
    }
    this.hasSheet()

    // スクロールにイベントリスナを追加
    document.addEventListener('mousewheel', this.mouseWheel, { passive: false })
  }
}
</script>
<style lang="scss" scoped>
#content {
  width: 1377px;
  height: 900px;
  margin: 15px;
  background: #eee;
  border: 1px solid #000000;
  border-radius: 5px 5px 5px 5px;
  position: relative;
}
#tab {
  display: inline-block;
  box-sizing: border-box;
  position: absolute;
  width: 240px;
  height: 97%;
  padding: 5px;
  margin: 15px;
  font-size: 13px;
  .tab_menu {
    width: auto;
    white-space: nowrap;
    background-color: #FFFFFF;
    border: 1px solid #000000;
    border-top: 0px;
    bottom: 0px;
    li {
      padding: 0px 20px 0px 9px;
      border-top: 1px solid #000000;
      background-color: #FFFFFF;
      cursor: pointer;
      font-weight: 600;
      font-size: 13px;
      vertical-align: bottom;
      &.active {
        background-color: #000000;
        color: #FFFFFF;
      }
      input {
        margin: 6px 0 6px 0;
      }
      .text {
        margin: 7px 0 7px 0;
        display: inline-block;
        cursor : pointer;
        vertical-align: top;
      }
    }
    .dtl_menu_list {
      padding: 0px;
      li {
        height: 26.5px;
      }
      li:first-child{
        border-top: 0px;
      }
      li:last-child{
        border-bottom: 0px;
      }
      .manufacture_doc_text {
        height: 90px;
        li {
          border-top: 0px;
          font-weight: 500;
          height: 18px;
          padding-left: 30px;
          padding-top: 2px;
          &.active {
            background-color: #000000;
            color: #FFFFFF;
          }
        }
      }
    }
    .tab_sub_menu {
      background-color: #ccc;
      height: 18px;
      font-size: 14px;
      padding: 5px 8px 6px 9px;
    }
    .tab_dtl_menu {
      margin-left: 22px;
      height: 15px;
    }
    .tab_name_area {
      width: 80%;
      display: inline-block;
    }
    .drop_icon_area {
      width: 20%;
      display: inline-block;
    }
  }
  .debug_tab {
    margin-top: 20px;
    li {
      padding: 0;
    }
    #output_debug {
      li {
        padding: 10px;
        margin: 10px;
        border-bottom: 1px solid #000000;
      }
    }
  }
  .button-area {
    height: 120px;
    padding-top: 14px;
    padding-bottom: 8px;
    box-sizing: border-box;
    li {
      padding-bottom: 8px;
    }
    button {
      margin: auto;
      height: 38px;
      font-size: 12px;
      img {
        vertical-align: middle;
        padding-right: 6px;
      }
    }
  }
}
#tab_contents {
  display: inline-block;
  background-color: #FFFFFF;
  border: 1px solid #000000;
  position: absolute;
  left: 250px;
  width: 1095px;
  height: 97%;
  padding: 15px;
  border-radius: 5px 5px 5px 5px;
  box-sizing: border-box;
  margin: 15px;
}
#arrow_left {
  margin-right: 3px;
}
#arrow_right {
  margin-left: 3px;
}
#sheet {
  height: 95%;
  width: 100%;
  background-color: white;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;
}
#sheet-form {
  padding-top: 20px;
  padding-left: 10px;
  &>div {
    display: inline-block;
  }
  select {
    cursor: pointer;
    margin-top: 6px;
  }
}
#sheet-disp-area {
  height: 95%;
  padding-left: 1px;
  padding-top: 6px;
  box-sizing: border-box;
  text-align: center;
}
.data-area {
  li {
    padding-top: 24px;
    padding-left: 12px;
    line-height: normal;
  }
  .text-title {
    font-size: 24px;
  }
}
.message {
  color: #ff4500
}
.triangle{
  position: absolute;
  left: 235px;
  border-top: 14px solid transparent;
  border-bottom: 13px solid transparent;
  border-left: 14px solid #000000;
  width: 0;
  height: 0;
  margin: auto;
}
/deep/ .output-caution{
  float: right;
  font-weight: 700;
  margin-top: 8px;
}
/deep/ .preview-content {
  height: 95%;
  width: 100%;
  background-color: white;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Sheet.vue